/*
 * Copyright (c) 2022 FMR LLC.
 * All Rights Reserved.
 * Fidelity Confidential Information.
 */

import { ClientConstants } from "@/client.constants";

class CalculationRequestModel {
    public bondType: string;
    public bondYield: number;
    public federalTaxRate: number;
    public state: string;
    public stateTaxRate: number;
    public localTaxRate: number;

    constructor(bondType: string, bondYield: number, federalTaxRate: number, state: string, stateTaxRate: number, localTaxRate: number) {
        this.bondType = bondType;
        this.bondYield = bondYield;
        this.federalTaxRate = federalTaxRate;
        this.state = state;
        this.stateTaxRate = stateTaxRate;
        this.localTaxRate = localTaxRate;
    }
}

class CalculationResponseModel {
    public cdYields: number[];
    public corpYields: number[];
    public inStateMuniYields: number[];
    public outOfStateMuniYields: number[];
    public treasuryAgencyYields: number[];
    public spdaYields: number[];

    constructor(data: any) {
        if (data.cdYields === undefined ||
            data.corpYields === undefined ||
            data.inStateMuniYields === undefined ||
            data.outOfStateMuniYields === undefined ||
            data.treasuryAgencyYields === undefined || 
            data.spdaYields === undefined) {
            throw new Error(ClientConstants.MISSING_RESPONSE_DATA);
        }

        this.cdYields = data.cdYields;
        this.corpYields = data.corpYields;
        this.inStateMuniYields = data.inStateMuniYields;
        this.outOfStateMuniYields = data.outOfStateMuniYields;
        this.treasuryAgencyYields = data.treasuryAgencyYields;
        this.spdaYields = data.spdaYields;
    }
}

export { CalculationRequestModel, CalculationResponseModel }